import { sha256 } from 'js-sha256';

module.exports = global.LPGlobals = {
  email: '',
  phoneNumber: '',
  setPhoneNumber: function (phoneNumber) {
    this.phoneNumber = phoneNumber ? sha256(phoneNumber) : '';
  },
  setEmail: function (email) {
    this.email = email ? sha256(email) : '';
  },
  getPhoneNumber: function () {
    return this.phoneNumber;
  },
  getEmail: function () {
    return this.email;
  },
};
